import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import dayOfYear from 'dayjs/plugin/dayOfYear'
import utc from 'dayjs/plugin/utc'

dayjs.extend(localizedFormat)
dayjs.extend(dayOfYear)
dayjs.extend(utc)

export { dayjs as dayJS }

export const getFormattedDate = (date?: string) => {
  return dayjs(date).format('D MMM YYYY, HH:mm')
}

// Renders the date in the active locale's native format (e.g. "July 31, 2026",
// "2026年7月31日", "31. Juli 2026").
export const formatDate = (date: string | Date, locale: string): string =>
  new Intl.DateTimeFormat(locale, { year: 'numeric', month: 'long', day: 'numeric' }).format(new Date(date))
